var map = {
	"./bg-BG.json": 1037,
	"./ca-ES.json": 72995,
	"./cs-CZ.json": 17736,
	"./de-DE.json": 52309,
	"./el-GR.json": 64081,
	"./en-US.json": 674,
	"./es-ES.json": 69167,
	"./et-EE.json": 89770,
	"./fi-FI.json": 15725,
	"./fr-FR.json": 77015,
	"./he-IL.json": 37439,
	"./it-IT.json": 68381,
	"./ja-JP.json": 5986,
	"./ko-KR.json": 40348,
	"./nb-NO.json": 82096,
	"./nl-NL.json": 19083,
	"./nn-NO.json": 9004,
	"./pl-PL.json": 60867,
	"./pt-BR.json": 80983,
	"./ro-RO.json": 28381,
	"./ru-RU.json": 62973,
	"./sk-SK.json": 37075,
	"./sv-SE.json": 37968,
	"./tr-TR.json": 22135,
	"./zh-CN.json": 40552
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 72407;